import Modal from 'components/_UI/Modal'
import Text from 'components/_UI/Text'
import Button from 'components/_UI/Button'
import paths from 'routes/paths'

export default function NoEstablishmentModal ({
    isOpen,
    onClose = () => {},
}) {
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <Text name='highlight'>
                Você precisa ter um estabelecimento criado para cadastrar produto.
            </Text>
            <Button path={paths.dashboard.establishment.profile}>
                Criar estabelecimento
            </Button>
        </Modal>
    )
}